import abstractModel from '../../core/MercatelyModel';
import { MERCATELY_API } from '../../constants/AppConstants';

const resource = `${MERCATELY_API}/outbound_follow_up_config`;

const model = abstractModel(resource);

model.getConfig = async () => model.get();

model.updateConfig = async (body, csrfToken) => model.update(body, csrfToken);

export default model;
